import {
  EvaEventsTable,
  tableData2,
} from "../data/EvaItems";
import RatioGroup from "@/components/RatioGroup.vue";
import SeasonSelect from "@/components/SeasonSelect.vue";
import router from "../router";
import { ElMessage } from "element-plus";


import { post } from "../utils/request";
import { getSeason, seasonTransfer } from "../utils/utilApi";

// import store from "../store";
export default {
  data() {
    return {
      activeTab: "first",
      showableComp: {
        showCommonEvaTable: false,
        showPersonalEvaTable: false,
        // 需要个性指标评定的集合
        showPersonalEvaList: false,
      },
      disableComp: {

      },
      EvaEventsTable: [],
      season: getSeason(),
      year: String(new Date().getFullYear()),
      CommonItems: [],
      tableData2: [],
      EvaEventsData: [],
      EvaEventsDone: [],
      selectedModel: "",
      // 共性指标评价细则
      normItems: [],
      colName: 0,
      normRateArr: [],
      // 每一项为指标(index, normId, upperLimit, maxScore, currentNum)
      normRatePrief: [],
      // 如果评好超过比例则不予提交
      submitFlag: false,
      loading: true,
      splitRate: [], // 存储不同对象的共性指标考核分别
    };
  },
  name: "EvaEvents",
  methods: {
    // 切换tab
    handleClick(tab, event) {
      if (this.activeTab == "first") {
        this.EvaEventsData = this.EvaEventsUnDone;
      } else if (this.activeTab == "second") {
        this.EvaEventsData = this.EvaEventsDone;
      }
    },
    handleEva(index, row) {
      if (row.normType == "共性指标") {
        this.splitRate = []; // 初始化
        this.loading = true;
        this.submitFlag = false;
        this.selectedModel = row;
        this.searchNorm();
        this.commonObjSearchBoth();
        // this.commonObjSearch(JSON.parse(JSON.stringify(row)));
        this.showableComp.showCommonEvaTable = true;
      } else if (row.normType == "个性指标") {
        row.season = this.season;
        row.year = this.year;
        router.push({
          name: "personal-eva",
          params: JSON.parse(JSON.stringify(row)),
        });
      }
    },
    formatter(row, column) {
      if (column.property == "season") {
        return seasonTransfer(row.season);
      } else if (column.property == "respPerson") {
        return row.respPersonName;
      } else {
        return row[column.property];
      }
    },

    /**
     * @function POST /evaEvents/search/batch
     * @description 查找代办事项和已办事项
     * 
     * @param year 年度
     * @param season 季度
     * @param roleIdList 当前用户的角色集合
     * @param userId 当前用户ID
     * 
     * @returns R.success().code(200).data("EvaEventsDone[], EvaEventsUnDone[]")
     * @returns 代办或已办事项需要包含考评模型相关属性（表eva_model和model_role）如：normType指标类型、status当前进度、season考核周期、subject考核主体、object考核对象、beginDate开始时间、modelId模型ID、evaType考评方式
     */
    evaEventsSearch() {
      let arr = JSON.parse(sessionStorage.getItem("roleList"));
      for (let i = 0, len = arr.length; i < len; i++) {
        arr[i] = arr[i].roleId;
      }
      let data = {
        year: this.year,
        season: this.season,
        roleIdList: arr,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      };
      post('/evaEvents/search/batch', JSON.stringify(data)).then((res) => {
        this.EvaEventsDone = JSON.parse(res.data.evaEventsDone);
        this.EvaEventsUnDone = JSON.parse(res.data.evaEventsUnDone);
        this.handleClick();
      });
    },
    /**
     * @function POST /commonItem/object/search
     * @description 查找共性指标的被评价对象
     * @param modelId 模型ID
     * @param object 被评分对象角色
     * @param userId 用户ID
     * @param roleIdList 当前用户的角色集合
     * @param evaType 评价方式（自评、互评、领导评、其他）
     * @param bureauId 单位（局）ID
     * 
     * @returns userArr[], 每个用户对象包括属性: userId被评分对象的用户ID, userName被评分对象的名字, department部门
     */
    commonObjSearch(row) {
      let arr = JSON.parse(sessionStorage.getItem("roleList"));
      for (let i = 0, len = arr.length; i < len; i++) {
        arr[i] = arr[i].roleId;
      }
      let data = {
        modelId: row.modelId,
        roleIdList: arr,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        object: row.object,
        evaType: row.evaType,
        bureauId: JSON.parse(sessionStorage.getItem("departmentInfo")).parentId
      };
      post('/commonItem/object/search', JSON.stringify(data)).then((res) => {
        this.tableData2 = JSON.parse(res.data.userArr);
      });
    },
    // 返回值接口
    commonObjSearch2(row) {
      let arr = JSON.parse(sessionStorage.getItem("roleList"));
      for (let i = 0, len = arr.length; i < len; i++) {
        arr[i] = arr[i].roleId;
      }
      let data = {
        modelId: row.modelId,
        roleIdList: arr,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        object: row.object,
        evaType: row.evaType,
        bureauId: JSON.parse(sessionStorage.getItem("departmentInfo")).parentId
      };
      return post('/commonItem/object/search', JSON.stringify(data));
    },
    // 合并当前考核主体共性指标的所有考核对象查询
    // rows为数组需要遍历查询
    async commonObjSearchBoth() {
      let commonRows = [];
      // console.log("1", this.EvaEventsUnDone);
      for (let i = 0; i < this.EvaEventsUnDone.length; i++) {
        if (this.EvaEventsUnDone[i].normType == "共性指标") {
          commonRows.push(this.EvaEventsUnDone[i]);
          this.splitRate.push({
            modelId: this.EvaEventsUnDone[i].modelId,
            modelRoleId: this.EvaEventsUnDone[i].modelRoleId,
            userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
            objNum: "",
          });
        }
      }
      let obj = [];
      for (let i = 0; i < commonRows.length; i++) {
        let accept = await this.commonObjSearch2(JSON.parse(JSON.stringify(commonRows[i])));
        accept = JSON.parse(accept.data.userArr);
        this.splitRate[i].objNum = accept.length;
        obj = obj.concat(accept);
      }
      this.tableData2 = obj;
    },
    // 共性指标统计计算
    onCal() {
      // 计算评价为好的比例是否超过限制
      // 初始化normRatePrief数组
      if (this.normRatePrief.length == 0) {
        let index = 0;
        for (let i = 0, len = this.normItems.length; i < len; i++) {
          let normItems = this.normItems[i].children;
          for (let j = 0; j < normItems.length; j++) {
            let item = {};
            // 序号，0~小项总数-1
            item.index = index++;
            // 小项指标ID
            item.normId = normItems[j].normId;
            // 指标名称
            item.normName = normItems[j].normName;
            // 小项最大限制
            // item.upperLimit = this.normItems[i].normRate[0].upperLimit;
            // item.upperLimit = normItems[j].normRate[0].upperLimit;
            item.upperLimit = this.normRateArr[i][j].upperLimit;
            // 判空
            // 小项最大得分
            item.maxScore = normItems[j].normScore;
            // 初始化当前评好的人数为0
            item.currentNum = 0;
            this.normRatePrief.push(item);
          }
        }
      }

      // 初始化评价为好的人数的统计数组
      for (let i = 0; i < this.normRatePrief.length; i++) {
        this.normRatePrief[i].currentNum = 0;
      }
      // this.goodNum = new Array(this.normRatePrief.length).fill(0);
      // 计算总分
      // console.log(this.tableData2)
      for (let i = 0, len = this.tableData2.length; i < len; i++) {
        let item = this.tableData2[i].c;
        let res = 0;
        for (let j = 0; j < item.length; j++) {
          res += item[j];
          if (item[j] == this.normRatePrief[j].maxScore) {
            // 评为好，则数组对应列+1
            // this.goodNum[j] += 1;
            this.normRatePrief[j].currentNum += 1;
          }
        }
        this.tableData2[i].totalScore = res;
        // item.totalScore = item.c1 + item.c2 + item.c3 + item.c4 + item.c5 + item.c6 + item.c7 + item.c8 + item.c9;
      }
      // console.log(this.normRatePrief);

      // 计算比例
      let personNum = this.tableData2.length;
      for (let i = 0; i < this.normRatePrief.length; i++) {
        // console.log(this.normRatePrief[i].currentNum, personNum * this.normRatePrief[i].upperLimit * 0.01);
        // 比例折算向上取整Math.ceil()
        if (this.normRatePrief[i].currentNum > Math.ceil(personNum * this.normRatePrief[i].upperLimit * 0.01)) {
          this.submitFlag = false;
          ElMessage.warning(this.normRatePrief[i].normName + "指标项超过评价为“好”的人数超过最大限制", {
            duration: 3 * 1000,
          });
          return;
        }
      }
      this.submitFlag = true;
    },
    /**
     * @function POST /commonItem/submit
     * @description 共性指标提交。1、common_sub和common_obj表记录分数；
     * @param data[]被打分者数组
     * @param data[i].userId 被打分者ID
     * @param data[i].totalScore 总分
     * @param data[i].c[] 被打分者各项得分细则
     * @param userId 打分者ID
     * @returns R.success().code(200).message("提交成功")
     */
    onSubmit() {
      // 提交前再做一次统计计算
      this.onCal();
      // for (let i = 0, len = this.tableData2.length; i < len; i++) {
      //   let item = this.tableData2[i];
      //   item.c = new Array();
      //   item.c[0] = item.c1;
      //   item.c[1] = item.c2;
      //   item.c[2] = item.c3;
      //   item.c[3] = item.c4;
      //   item.c[4] = item.c5;
      //   item.c[5] = item.c6;
      //   item.c[6] = item.c7;
      //   item.c[7] = item.c8;
      //   item.c[8] = item.c9;
      // }
      if (this.submitFlag == false) {
        setTimeout(() => {
          ElMessage.error("评价为好的人数超过限制，不允许提交", {
            duration: 3 * 1000,
          });
        }, 10);
        return;
      }
      // let data = {
      //   data: this.tableData2,
      //   userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      //   modelId: this.selectedModel.modelId,
      //   modelRoleId: this.selectedModel.modelRoleId,
      // };
      let start = 0;
      for (let i = 0; i < this.splitRate.length; i++) {
        this.splitRate[i].data = this.tableData2.slice(start, start + this.splitRate[i].objNum);
        start = start + this.splitRate[i].objNum;
      }

      post('/commonItem/submit', JSON.stringify(this.splitRate)).then((res) => {
        if (res.code == 200) {
          // this.selectedModel.status = "已评分";
          // for (let j = this.splitRate.length - 1; j >= 0; j--) {
          //   for (let i = 0, len = this.EvaEventsUnDone.length; i < len; i++) {
          //     if (this.EvaEventsUnDone[i].modelId == this.splitRate[j].modelId) {
          //       this.EvaEventsUnDone[i].status = "已评分";
          //       this.EvaEventsUnDone.splice(i, 1);
          //       this.EvaEventsDone.push(this.EvaEventsUnDone[i]);
          //     }
          //   }
          // }
          this.evaEventsSearch();
        }
        this.showableComp.showCommonEvaTable = false;
      });
    },
    // 查找本局的共性指标及对应的每一小项内容
    // searchNorm() {
    //   let data = {
    //     normType: 1,
    //     // departmentId: 100,
    //     type: 3,
    //   }
    //   if (JSON.parse(sessionStorage.getItem('departmentInfo')).level == 1) {
    //     data.departmentId = JSON.parse(sessionStorage.getItem('departmentInfo')).parentId;
    //   } else {
    //     data.departmentId = JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId;
    //   }
    //   post('/norm/search/batch', JSON.stringify(data)).then(res => {
    //     if (res.code == 200) {
    //       // 共性指标下属指标树形结构集合
    //       this.normItems = JSON.parse(res.data.normItems)[0].children;
    //       console.log("##", this.normItems);
    //       for (let i = 0; i < this.normItems.length; i++) {
    //         // 中项指标的名称分数集合
    //         let rateArr = this.normItems[i].normRate;
    //         this.normRateArr.push({ rateNames: [], rateScores: [] });
    //         // 扩充normRateArr数组到小项有则用小项的，小项没有看大项
    //         // 缩小normRate集合的数据，只取名称和分数
    //         for (let j = 0; j < rateArr.length; j++) {
    //           this.normRateArr[i].rateNames.push(rateArr[j].rateName);
    //           this.normRateArr[i].rateScores.push(rateArr[j].rateScore);
    //         }
    //         // 三级指标
    //         for (let m = 0; m < this.normItems[i].children.length; m++) {
    //           let rateArr2 = this.normItems[i].children.normRate;
    //           if (rateArr2.length == 0) {
    //             return;
    //           }
    //         }
    //       }
    //     }
    //   });
    // },
    searchNorm() {
      let data = {
        normType: 1,
        // departmentId: 100,
        type: 3,
      }
      if (JSON.parse(sessionStorage.getItem('departmentInfo')).level == 1) {
        data.departmentId = JSON.parse(sessionStorage.getItem('departmentInfo')).parentId;
      } else {
        data.departmentId = JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId;
      }
      post('/norm/search/batch', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          // 共性指标下属指标树形结构集合
          this.normItems = JSON.parse(res.data.normItems)[0].children;
          for (let i = 0; i < this.normItems.length; i++) {
            let rateArr = this.normItems[i].normRate;
            this.normRateArr[i] = new Array();
            // 三级指标
            for (let j = 0; j < this.normItems[i].children.length; j++) {
              let rateArr2 = this.normItems[i].children[j].normRate;
              this.normRateArr[i].push(new Array());
              this.normRateArr[i][j] = { rateNames: [], rateScores: [] };

              // this.normRateArr[i][j].push({ rateNames: [], rateScores: [] });
              // 如果三级指标没有查询到normRate则使用二级指标的
              if (rateArr2 != null && rateArr2 != "" && rateArr2.length == 0) {
                for (let m = 0; m < rateArr.length; m++) {
                  this.normRateArr[i][j].rateNames.push(rateArr[m].rateName);
                  this.normRateArr[i][j].rateScores.push(rateArr[m].rateScore);
                }
                this.normRateArr[i][j].upperLimit = rateArr[0].upperLimit;
              } else {
                // 如果三级指标查询到normRate则使用三级指标的
                for (let m = 0; m < rateArr2.length; m++) {
                  this.normRateArr[i][j].rateNames.push(rateArr2[m].rateName);
                  this.normRateArr[i][j].rateScores.push(rateArr2[m].rateScore);
                }
                this.normRateArr[i][j].upperLimit = rateArr2[0].upperLimit;
              }
            }
          }
        }
        this.loading = false;
      });
    },
    // 评分后及时修改每个用户的得分数组
    // index为第几行，index2为父集下标，index3为子集下标
    acceptScore(index, event, index2, index3) {
      let cIndex = 0; // 计算得到修改的列为整体为第几列
      if (index2 > 0) {
        let i = index2;
        while (i-- > 0) {
          cIndex += this.normItems[index2 - i - 1].children.length;
        }
      }
      cIndex += index3;
      if (this.tableData2[index].c == null) {
        this.tableData2[index].c = [];
      }
      this.tableData2[index].c[cIndex] = event;
    },
    // 自增ID
    getAutoIndex() {
      this.colName += 1;
      return this.colName;
    }

  },
  components: {
    RatioGroup,
    SeasonSelect
  },
  created() {
    this.EvaEventsTable = EvaEventsTable;
    this.tableData2 = tableData2;

    this.evaEventsSearch();
    this.EvaEventsData = this.EvaEventsUnDone;
  },
  watch: {
    year() {
      this.evaEventsSearch();
    },
    season() {
      this.evaEventsSearch();
    }
  },
};